<div *ngIf="isOpen" 
     class="popup-overlay fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 animate-fade-in"
     (click)="onOverlayClick($event)">
  <div [ngClass]="{
    'bg-purple-100 border-purple-400 text-purple-900': type === 'success',
    'bg-white border-red-400 text-red-900': type === 'error'
  }" 
       class="border-l-4 p-6 rounded-lg shadow-xl max-w-sm w-full text-center flex flex-col items-center animate-popup relative">
    
    <!-- Close button -->
    <button (click)="closePopup()" 
            class="absolute top-3 right-3 text-gray-600 hover:text-gray-900 transition-transform transform hover:scale-110">
      <svg xmlns="http://www.w3.org/2000/svg" 
           class="h-6 w-6" 
           viewBox="0 0 20 20" 
           fill="currentColor">
        <path fill-rule="evenodd" 
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" 
              clip-rule="evenodd" />
      </svg>
    </button>

    <!-- Icon -->
    <div class="mb-4">
      <svg *ngIf="type === 'success'" class="h-16 w-16 text-purple-500" fill="currentColor" viewBox="0 0 20 20">
        <path fill-rule="evenodd" 
              d="M16.707 5.293a1 1 0 00-1.414-1.414L8 11.172l-3.293-3.293a1 1 0 00-1.414 1.414l4 4a1 1 0 001.414 0l8-8z" 
              clip-rule="evenodd"/>
      </svg>
      <svg *ngIf="type === 'error'" class="h-16 w-16 text-red-500 text-bold" fill="currentColor" viewBox="0 0 20 20">
        <path fill-rule="evenodd" 
        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" 
        clip-rule="evenodd" />
      </svg>
    </div>

    <!-- Message -->
    <p class="text-xl font-semibold">
      {{ type === 'success' ? 'Success!' : 'Error' }}
    </p>
    <p class="mt-2 text-sm leading-relaxed px-4">{{ message }}</p>

    <!-- Close button (extra) -->
    <button (click)="closePopup()" 
            class="mt-4 px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700 transition">
      Close
    </button>

  </div>
</div>